import { Autocomplete, Box, Chip, TextField, Tooltip, Typography } from '@mui/material'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  options: string[]
  value: string[]
  onChange: (next: string[]) => void
  /** FU-m-2: per-dim pre-selection warning. Returns the ⚠ tooltip text for a group-by dim a
   *  sibling driver fact can't carry, or undefined for a non-breaker dim. */
  warningFor?: (dim: string) => string | undefined
}

export function GroupBySelect({ options, value, onChange, warningFor }: Props) {
  return (
    <Autocomplete
      multiple
      sx={{ minWidth: 240 }}
      options={options}
      value={value}
      onChange={(_, next) => onChange(next)}
      renderOption={(props, option) => {
        const warning = warningFor?.(option)
        return (
          <Box component="li" {...props} key={option}>
            <Typography variant="body2">{option}</Typography>
            {warning ? (
              <Tooltip title={warning}>
                <WarningAmberIcon color="warning" fontSize="small" sx={{ ml: 0.5 }} />
              </Tooltip>
            ) : null}
          </Box>
        )
      }}
      renderInput={(params) => <TextField {...params} label={CONTROLS.groupBy} />}
      renderTags={(v, getTagProps) =>
        v.map((option, index) => {
          const warning = warningFor?.(option)
          const { key, ...tagProps } = getTagProps({ index })
          const chip = (
            <Chip
              key={key}
              {...tagProps}
              label={option}
              icon={warning ? <WarningAmberIcon color="warning" /> : undefined}
            />
          )
          return warning ? (
            <Tooltip key={key} title={warning}>
              {chip}
            </Tooltip>
          ) : (
            chip
          )
        })
      }
    />
  )
}
